export default __webpack_public_path__ + "static/media/kitchen2-1920w.4217f59b.png";